import axios from "axios";
import { headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchNewsLetterBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-news-letter-banners?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchNewsLetterData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_strapiUrl}/api/frcsit-news-letter-news-letters?populate=*`,
        { headers }
      );
      return response.data.data;
    } catch (error) {
      dynamicFailed("Server Error");
    }
  };